// changelog.js — TDA Events Platform
// Neueste Version zuerst. Typen: feature | major | improvement | bugfix | security

export const CHANGELOG = [
  {
    version: '2.4.0',
    date: '2026-09-27',
    type: 'feature',
    title: 'Einzelstarter, Turnierinfo und Mails an Vereine',
    highlights: [
      'Neue Ansicht „Einzelstarter": wer allein in seiner Kategorie steht, mit passenden Vorschlägen, Umlegen und Nachricht an den Verein',
      'Neue Ansicht „Mails an Vereine": Anmeldebestätigung und Turnierinfo mit Matte und Uhrzeit je Start, mit Vorschau',
      'Vereine sehen im Vereinsbereich Matte und geplante Uhrzeit ihrer Starts',
      'Alle Mails an Vereine werden archiviert und kommen zuverlässiger an',
    ],
  },
  {
    version: '2.3.2',
    date: '2026-09-27',
    type: 'improvement',
    title: 'Anmeldung am Handy bedienbar, mit Tipps',
    highlights: [
      'Am Handy nutzt das Anmeldefenster den ganzen Bildschirm; Wettkämpfer und Kategorien sind erreichbar',
      'Kurze Tipps in jedem Schritt, wegklickbar',
      'Fehlendes Gewicht steht schon bei der Auswahl der Wettkämpfer, nicht erst bei den Kategorien',
      'Weniger Knöpfe: Unterfilter erscheinen erst nach Wahl einer Disziplin, Vereine sehen nur ihre zwei Schritte',
    ],
  },
  {
    version: '2.3.1',
    date: '2026-09-27',
    type: 'improvement',
    title: 'Teamgebühr je Team, strenge Kategorieprüfung, Lehrgänge mit Zahlung',
    highlights: [
      'Die Teamgebühr gilt je Team: aufgeteilt auf die Mitglieder oder als eine Position für den Verein, wählbar je Turnier',
      'Alter, Geschlecht, Gewicht und Stufe werden beim Anmelden verbindlich geprüft, das Alter zum Stichtag des Turniers',
      'Lehrgänge zeigen nach der Anmeldung Betrag, Bankverbindung und Verwendungszweck',
      'Die Warteliste rückt automatisch nach, wenn jemand absagt oder mehr Plätze frei werden',
    ],
  },
  {
    version: '2.3.0',
    date: '2026-09-27',
    type: 'improvement',
    title: 'Jede Veranstaltung bekommt das passende Formular',
    highlights: [
      'Passdaten fragt nur noch das Camp ab; Lehrgänge und Seminare brauchen Name und E-Mail',
      'Veranstaltungen mit persönlicher Einladung zeigen Beschreibung und Uhrzeit statt eines Formulars',
      'Zustimmung zur Datenverarbeitung, Schutz gegen doppelte Anmeldungen und Formular-Bots',
      'Am Handy einspaltig, mit Kopfzeile und Weg zurück zur Übersicht',
    ],
  },
  {
    version: '2.2.9',
    date: '2026-09-27',
    type: 'improvement',
    title: 'Anmeldung für Vereine in einem Schritt',
    highlights: [
      '„Anmelden" führt direkt zu Sportlern und Kategorien, ohne Umweg über eine zweite Seite',
      'Teamname und Teammitglieder bei Duo- und Team-Kategorien bleiben gespeichert',
      'Schnellanmeldung und Athletenkonto fragen das Gewicht ab, das für die Gewichtsklasse nötig ist',
      'Angeboten werden nur noch die Kategorien, die der Veranstalter für das Turnier ausgeschrieben hat',
      'QR-Schnellanmeldungen lassen sich freigeben und bekommen ihre Startgebühr',
      'Nach einem Storno ist eine erneute Anmeldung in derselben Kategorie möglich',
    ],
  },
  {
    version: '2.2.8',
    date: '2026-08-07',
    type: 'security',
    title: 'Schnittstellen geben weniger preis',
    highlights: [
      'Status- und Fehlerauskünfte nennen keine internen Kennzahlen und keine Endpunktlisten mehr',
      'Der Divisionen-Katalog ist an eine Anmeldung gebunden; die Anmeldelinks nutzen ihren eigenen Zugang',
      'Anlegen, Ändern und Löschen von Kategorien meldet sich wieder korrekt an',
    ],
  },
  {
    version: '2.2.7',
    date: '2026-07-08',
    type: 'feature',
    title: 'Teilnehmer laden Brief selbst herunter',
    highlights: [
      'Nach der Selbst-Anmeldung: Download-Button für den eigenen Visa-Einladungsbrief',
      'Token-geschützt (kein Zugriff auf fremde Briefe/Passdaten)',
    ],
  },
  {
    version: '2.2.6',
    date: '2026-07-08',
    type: 'improvement',
    title: 'Events im Header-Dropdown + Modal-Fix',
    highlights: [
      'Header-Dropdown listet jetzt auch „Events & Camps" (neben Turnieren)',
      'Dialoge opak & höhenbegrenzt (scrollen im Rahmen) – nicht mehr durchsichtig',
    ],
  },
  {
    version: '2.2.5',
    date: '2026-07-08',
    type: 'feature',
    title: 'Camp-Selbstanmeldung per Link',
    highlights: [
      'Öffentlicher Anmelde-Link je Camp – Teilnehmer tragen ihre Passdaten selbst ein (/camp/:id)',
      'Zweisprachiges Formular (EN/DE), kein Login nötig',
      'Link im Camp-Panel kopierbar; Admin-Fallback „Teilnehmer hinzufügen"',
    ],
  },
  {
    version: '2.2.4',
    date: '2026-07-08',
    type: 'bugfix',
    title: 'Menüpunkt „Lehrgänge & Camps"',
    highlights: [
      'Events-/Camp-Bereich war nicht im Menü verlinkt – jetzt Kachel in der Organisation-Übersicht',
      'Trainingscamps inkl. Visa-Briefe-Assistent darüber erreichbar',
    ],
  },
  {
    version: '2.2.3',
    date: '2026-07-08',
    type: 'feature',
    title: 'Briefe-Assistent: drucken, per E-Mail senden, Kopien',
    highlights: [
      'Assistent: Sammelbrief / Einzelbrief / Einzelbriefe an alle Teilnehmer',
      'Ausgabe wählbar: PDF herunterladen (Ausdruck) oder per E-Mail',
      'E-Mail-Empfänger: Botschaft, Teilnehmer oder eigene Adresse',
      'Anzahl Ausfertigungen (Kopien) je Brief einstellbar; Botschafts-E-Mail speicherbar',
    ],
  },
  {
    version: '2.2.2',
    date: '2026-07-08',
    type: 'improvement',
    title: 'Visa-Brief mit Verbands-Briefkopf & gebrandete E-Mail',
    highlights: [
      'Offizieller Briefkopf mit TDA-Verbandslogo (Tiger & Dragon Association Int\'l) im PDF',
      'Begleit-E-Mail im TDA-Markenlayout (Banner) statt Klartext',
    ],
  },
  {
    version: '2.2.1',
    date: '2026-07-08',
    type: 'improvement',
    title: 'Visa-Brief: fester Absender pro Camp',
    highlights: [
      'Absender (Organisation, Ansprechpartner, Anschrift, E-Mail, Telefon) pro Camp hinterlegbar',
      'Erscheint fest im Briefkopf & in der Unterschrift – unabhängig vom Login-Konto',
    ],
  },
  {
    version: '2.2.0',
    date: '2026-07-07',
    type: 'feature',
    title: 'Trainingscamp & Visa-Einladungsbriefe',
    highlights: [
      'Event-Typ "Camp" mit Botschafts-/Visa-Daten (Zielland, Botschaftsanschrift)',
      'Passdaten je Teilnehmer erfassen (Reisepass, Nationalität, Geburtsort, Anschrift)',
      'Einzel-Einladungsbrief pro Teilnehmer als PDF – zweisprachig Deutsch/Englisch',
      'Sammel-Nominierungsschreiben mit Teilnehmer-Tabelle als PDF (DE/EN)',
    ],
  },
  {
    version: '2.1.0',
    date: '2026-03-23',
    type: 'feature',
    title: 'Staff-Management & Einsatzplan',
    highlights: [
      'Neue Rollen: Turnierleitung, Anmeldung, Ombudsmann',
      'Mehrere Rollen pro Person möglich',
      'Vollständiger Einsatzplan mit Matten-Raster',
      'Rollenbasierte Filterung in Zuweisung-Dropdowns',
    ],
  },
  {
    version: '2.0.0',
    date: '2026-03-20',
    type: 'major',
    title: 'Formen-Übersicht & Mattenfläche',
    highlights: [
      'Formen-Dashboard: Kategorie-Übersicht mit Matte-Zuweisung',
      'Neuer Mattenfläche-Bereich mit Schreiber-Links',
      'Turnier-Auswahl jetzt im globalen Header sichtbar',
      'Hilfe-Modal mit Modulbeschreibungen und Versionierung',
    ],
  },
  {
    version: '1.9.0',
    date: '2026-03-10',
    type: 'feature',
    title: 'Saison-Rangliste',
    highlights: [
      'Saison-Rangliste für TDA-weit verwaltbar',
      'Öffentliches Widget für tda-intl.com und tda-vib.de',
      'Veröffentlichen / Zurückziehen per Schalter',
    ],
  },
  {
    version: '1.8.0',
    date: '2026-02-15',
    type: 'feature',
    title: 'Kampfflächen-Manager',
    highlights: [
      'Matten und Bereiche anlegen und benennen',
      'Matten Formen-Kategorien zuordnen',
      'Nummernvergabe für Mattenübersicht',
    ],
  },
  {
    version: '1.7.0',
    date: '2026-01-20',
    type: 'improvement',
    title: 'Wettkämpfer-Dashboard Überarbeitung',
    highlights: [
      'Kompakte Filter-Leiste (Gewicht, Alter, Level in einer Zeile)',
      'Statistik-Chips statt großer Stat-Karten',
      'Schnellsuche nach Name',
    ],
  },
];
